
import React, { useEffect, useState } from "react";
import API from '../Services/Location'
import APIS from '../Services/Auth'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LocationList from "../Components/Location";
import CenterList from ".";

const AddCenter = () => {
    const [name, setName] = useState("")
    const [phoneNo, setPhoneNo] = useState("")
    const [email, setEmail] = useState("")
    const [gstNo, setGstNo] = useState("")
    const [webSite, setWebSite] = useState("")
    const [address, setAddress] = useState("")
    const [logo, setLogo] = useState("")
    const [pincode, setPincode] = useState("")
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [errors, setErrors] = useState({});
    const [countryId, setCountryId] = useState(1)
    const [logoPreview, setLogoPreview] = useState(null);

    const [locationId, setLocationId] = useState("");
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [availableRoom, setAvailableRoom] = useState("");
    const [chiChiImage, setChiChiImage] = useState(null);
    const [chiChiPreview, setChiChiPreview] = useState(null);
    const [fssaiNumber, setFssaiNumber] = useState("");
    

    const getCityData = async (pincode) => {
        try {
            const response = await APIS.getCity(pincode);
            const postData = response?.data?.data;
            if (postData) {
                setCity(postData?.city_name || "");
                setState(postData?.state_name || "");
            } else {
                console.log("No city or state data found in the response.");
                toast.warning('No city or state data found in the response');
            }
        } catch (error) {
            console.error("Error fetching city data:", error.message || error);
        }
    };

    const validateFields = () => {
        const errors = {};

        const isValidEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        const isValidWebsite = (webSite) =>
            /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/.test(webSite);

        const isValidNumber = (value) =>
            /^-?\d+(\.\d+)?$/.test(value);

        const isValidRoom = (value) => /^\d+$/.test(value);
        if (!name) {
            errors.name = "Name is required";
        }
        else if (!/^[A-Za-z\s]+$/.test(name)) {
            errors.name = "Name can only contain letters and spaces";
        }
        if (!address) {
            errors.address = "Address is required";
        }

        if (!pincode || pincode?.toString()?.length !== 6) {
            errors.pincode = "Invalid PinCode";
        }

        if (!(phoneNo?.trim())) {
            errors.phoneNo = "Mobile number is required";
        } else if (!/^\d{10}$/.test(phoneNo)) {
            errors.phoneNo = "Mobile number must be 10 digits";
        }

        if (email?.trim() && !isValidEmail(email)) {
            errors.email = "Invalid email format";
        }

        if (webSite?.trim() && !isValidWebsite(webSite)) {
            errors.webSite = "Invalid website format";
        }

        if (!gstNo) {
            errors.gstNo = "GST Number is required";
        } else if (!/^[0-9]{2}[A-Z a-z]{5}[0-9]{4}[A-Z a-z]{1}[0-9A-Z a-z]{3}$/.test(gstNo)) {
            errors.gstNo = "GST Number must be exactly 15 characters (alphanumeric)";
        }

        if (latitude?.trim() && !isValidNumber(latitude)) {
            errors.latitude = "Latitude must be a valid number";
        }
        if (longitude?.trim() && !isValidNumber(longitude)) {
            errors.longitude = "Longitude must be a valid number";
        }
        if (!availableRoom) {
            errors.availableRoom = "If party rooms are not available on respective center then add 0";
        }
        else if (availableRoom?.trim() && !isValidRoom(availableRoom)) {
            errors.availableRoom = "Party rooms must be a valid number";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;
            case "address":
                setAddress(value);
                break;
            case "pincode":
                setPincode(value);

                if (value.length < 6) {
                    setCity("");
                    setState("");
                    return;
                }
                if (value.length === 6) {
                    getCityData(value);
                }
                break;
            case "countryId":
                setCountryId(value);
                break;
            case "phoneNo":
                setPhoneNo(value);
                break;
            case "webSite":
                setWebSite(value);
                break;
            case "gstNo":
                setGstNo(value);
                break;
            case "email":
                setEmail(value);
                break;
            case "logo":
                setLogo(value);
                break;
            case "latitude":
                setLatitude(value);
                break;
            case "longitude":
                setLongitude(value);
                break;
            case "locationId":
                setLocationId(value);
                break;
            case "availableRoom":
                setAvailableRoom(value);
                break;
                  case "fssaiNumber":
                setFssaiNumber(value);
                break;
            default:
                break;
        }
    };

    const handleImageChange = (event, type) => {
        const file = event.target.files[0];

        if (!file) return;

        const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
        const maxSize = 5 * 1024 * 1024;

        if (!allowedFormats.includes(file.type)) {
            toast.error("Only JPG, PNG and GIF formats are allowed.");
            event.target.value = '';
            return;
        }

        if (file.size > maxSize) {
            toast.error("File size must be 5MB or smaller.");
            event.target.value = '';
            return;
        }

        // 🔥 Type based handling
        if (type === "logo") {
            setLogo(file);
            setLogoPreview(URL.createObjectURL(file));
        }

        if (type === "chichi") {
            setChiChiImage(file);
            setChiChiPreview(URL.createObjectURL(file));
        }
    };
    const addLocations = async () => {
        // console.log('locationId', locationId);
        if (!validateFields()) return;

        const formData = new FormData();
        if (email == '') {
            formData.append("company_id", "1");
            formData.append("name", name);
            formData.append("phone_no", phoneNo);
            formData.append("gst_no", gstNo);
            formData.append("website", webSite);
            formData.append("address", address);
            formData.append("pincode", pincode);
            formData.append("country_id", countryId);
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);
            formData.append('available_room', availableRoom);
            formData.append('fassi_no',fssaiNumber)
        }
        else {
            formData.append("company_id", "1");
            formData.append("name", name);
            formData.append("phone_no", phoneNo);
            formData.append("email", email);
            formData.append("gst_no", gstNo);
            formData.append("website", webSite);
            formData.append("address", address);
            formData.append("pincode", pincode);
            formData.append("country_id", countryId);
            formData.append("latitude", latitude);
            formData.append("longitude", longitude);
            formData.append('available_room', availableRoom);
            formData.append('fassi_no',fssaiNumber)
        }
        if (locationId != '') {
            formData.append("is_clone", '1');

            const cloneData = {
                cloneLocationId: locationId,
                tabs: ["sales_tab", "product_type", "product"]
            };
            formData.append("clone_data", JSON.stringify(cloneData));
        }
        else {
            formData.append("clone_data", JSON.stringify({}));
        }

        if (logo instanceof File) {
            formData.append("logo", logo);
        } else {
            console.warn("Logo is not a valid File object", logo);
        }
        if (chiChiImage instanceof File) {
            formData.append("brand_image", chiChiImage);
        }

        try {
            const response = await API.addLocation(formData);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Location added successfully!");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(response?.data?.message || "Location addition failed.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }

            if (error.response) {
                if (error.response.data?.errors) {
                    error.response.data.errors.forEach(err => {
                        toast.error(err.msg);
                    });
                } else {
                    const errorMessage = error.response.data?.message || `Error: ${error.response.status}`;
                    toast.error(errorMessage);
                }
            } else if (error.request) {
                console.error("Request error:", error.request);
                toast.error("No response from server. Please check your connection.");
            } else {
                console.error("Error message:", error.message);
                toast.error("Something went wrong. Please try again.");
            }
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addLocations();

    };
    const handleCancel = () => {
        setTimeout(() => window.location.reload());
        setName("")
        setCity("")
        setPhoneNo("")
        setAddress("")
        setEmail("")
        setGstNo("")
        setCountryId("")
        setWebSite("")
        setLogo("")
        setPincode("")
    }


    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">

                        <div className="card-body">
                            <h4 className="card-title">Add New Center</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">Name <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtname"
                                                placeholder="Name"
                                                value={name}
                                                onChange={(e) => handleFieldChange(e, "name")}
                                            />
                                            {errors.name && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.name}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Address">Address <span style={{ color: "red" }}>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                id="txtaddress"
                                                placeholder="Address"
                                                rows={1}
                                                value={address}
                                                onChange={(e) => handleFieldChange(e, "address")}
                                            />
                                            {errors.address && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.address}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="PinCode">PinCode <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtpincode"
                                                placeholder="Pin Code"
                                                maxLength={6}
                                                value={pincode}
                                                onChange={(e) => handleFieldChange(e, "pincode")}
                                            />
                                            {errors.pincode && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.pincode}</span>}
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="email">City</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtcity"
                                                placeholder={city}
                                                value={city}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="state">State</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtstate"
                                                placeholder={state}
                                                value={state}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="Country">Country</label>
                                            <select className="form-select" id="ddlCountry" value={countryId}
                                                onChange={(e) => handleFieldChange(e, "countryId")} >
                                                <option value={1}>India</option>
                                            </select>
                                            {errors.countryId && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.countryId}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="phone">Phone Number <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                maxLength={10}
                                                className="form-control"
                                                id="txtmobile"
                                                placeholder="Phone Number"
                                                value={phoneNo}
                                                onChange={(e) => handleFieldChange(e, "phoneNo")}
                                            />
                                            {errors.phoneNo && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.phoneNo}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Website">Website</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtWebsite"
                                                placeholder="Website"
                                                value={webSite}
                                                onChange={(e) => handleFieldChange(e, "webSite")}
                                            />
                                            {errors.webSite && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.webSite}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Website">GST No <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtgstno"
                                                placeholder="GST No"
                                                style={{ "text-transform": "uppercase" }}
                                                value={gstNo}
                                                maxLength={15}
                                                onChange={(e) => handleFieldChange(e, "gstNo")}
                                            />
                                            {errors.gstNo && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.gstNo}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Email">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="txtemail"
                                                placeholder="Email"
                                                value={email}
                                                onChange={(e) => handleFieldChange(e, "email")}
                                            />
                                            {errors.email && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.email}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="Email">Latitude</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtemail"
                                                placeholder="Latitude"
                                                value={latitude}
                                                maxLength={10}
                                                onChange={(e) => handleFieldChange(e, "latitude")}
                                            />
                                            {errors.latitude && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.latitude}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="Email">Longitude</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtemail"
                                                placeholder="Longitude"
                                                value={longitude}
                                                maxLength={10}
                                                onChange={(e) => handleFieldChange(e, "longitude")}
                                            />
                                            {errors.longitude && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.longitude}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="Email">Available Party Room</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtroom"
                                                placeholder="Available Room"
                                                value={availableRoom}
                                                onChange={(e) => handleFieldChange(e, "availableRoom")}
                                            />
                                            {errors.availableRoom && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.availableRoom}</span>}
                                        </div>
                                    </div>


                                      <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="Email">FSSAI Number</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtroom"
                                                placeholder="FSSAI Number"
                                                value={fssaiNumber}
                                                onChange={(e) => handleFieldChange(e, "fssaiNumber")}
                                            />
                                            {errors.fssaiNumber && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.fssaiNumber}</span>}
                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Website">Upload Logo</label>
                                            <input
                                                accept="image/png, image/gif, image/jpeg"
                                                type="file"
                                                className="form-control"
                                                id="txtimage"
                                                onChange={(e) => handleImageChange(e, "logo")}
                                            />

                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="Website">Chi-Chi Image</label>
                                            <input
                                                accept="image/png, image/gif, image/jpeg"
                                                type="file"
                                                className="form-control"
                                                onChange={(e) => handleImageChange(e, "chichi")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <LocationList
                                                selectedLocation={locationId}
                                                label="Clone From Center"
                                                isRequired={false}
                                                setSelectedLocation={(location) => {
                                                    setLocationId(location);
                                                    if (location.trim()) {
                                                        setErrors((prevErrors) => {
                                                            const updatedErrors = { ...prevErrors };
                                                            delete updatedErrors.locationId;
                                                            return updatedErrors;
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            {logoPreview && (
                                                <div className="mt-2">
                                                    <img src={logoPreview || "No Image Available"} alt="Logo Preview" style={{ width: '100px', height: 'auto' }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            {chiChiPreview && (
                                                <div className="mt-2">
                                                    <img
                                                        src={chiChiPreview}
                                                        alt="ChiChi Preview"
                                                        style={{ width: '100px', height: 'auto' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">

                                    <button
                                        onClick={handleSubmit}
                                        type="button"
                                        className="btn btn-primary"
                                    >
                                        Submit
                                    </button>

                                    <button onClick={handleCancel} className="btn btn-light ms-2">Cancel</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <CenterList />
        </div>
    );
};

export default AddCenter;
